import { RelatedPromptsXStoreModule } from '../types';

// eslint-disable-next-line max-len
export const saveRelatedPromptsResponse: RelatedPromptsXStoreModule['actions']['saveRelatedPromptsResponse'] =
  ({ commit }, { query, syntheticSuggestions }) => {
    if (syntheticSuggestions && query) {
      commit('setRelatedPrompts', syntheticSuggestions);
    }
  };
